<div class="container">
  <kp-mobile-promo [isFullScreen]="true"></kp-mobile-promo>
</div>
